import { render, staticRenderFns } from "./settings-company-accounts.vue?vue&type=template&id=0cd89c59&"
import script from "./settings-company-accounts.ts?vue&type=script&lang=ts&"
export * from "./settings-company-accounts.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports